var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgAttachImageIcon = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9996 22H18.1383C20.0474 22 21.002 22 21.5349 21.601C21.9993 21.2534 22.2899 20.7211 22.3312 20.1425C22.3786 19.4785 21.8624 18.6755 20.8301 17.0696L20.1914 16.0761C19.2955 14.6825 18.8476 13.9858 18.2781 13.7451C17.7804 13.5348 17.2188 13.5348 16.7212 13.7451C16.1516 13.9858 15.7037 14.6826 14.8079 16.0761L14.4996 16.5556M17.9996 22L14.4996 16.5556M17.9996 22H5.86095C3.95181 22 2.99724 22 2.46433 21.601C1.99992 21.2534 1.70937 20.7211 1.66804 20.1425C1.62061 19.4785 2.1368 18.6755 3.16918 17.0696L6.30785 12.1872C7.2037 10.7937 7.65163 10.0969 8.22119 9.85622C8.71884 9.64594 9.2804 9.64594 9.77806 9.85622C10.3476 10.0969 10.7955 10.7937 11.6914 12.1872L14.4996 16.5556M19.9996 5C19.9996 6.65685 18.6565 8 16.9996 8C15.3428 8 13.9996 6.65685 13.9996 5C13.9996 3.34315 15.3428 2 16.9996 2C18.6565 2 19.9996 3.34315 19.9996 5Z",
    stroke: "#23252F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAttachImageIcon);
export default ForwardRef;